import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { SectionLabel } from "@/components/primitives";
import { approachSteps } from "@/data/content";

export default function ApproachTimeline({ withHeader = true }) {
  return (
    <section
      id="approach"
      data-testid="approach-section"
      className="relative overflow-hidden border-t border-fs-border bg-fs-bg py-24 lg:py-32"
    >
      <div className="fs-grid-bg pointer-events-none absolute inset-0 opacity-30" aria-hidden="true" />
      <div className="fs-shell relative">
        {withHeader && (
          <div className="max-w-2xl">
            <Reveal>
              <SectionLabel testId="approach-label">Our Approach</SectionLabel>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-6 fs-h2">
                From unclear <span className="fs-italic-gold">to operational.</span>
              </h2>
            </Reveal>
          </div>
        )}

        {/* Desktop horizontal / mobile vertical */}
        <div className="mt-16">
          {/* connecting line */}
          <div className="relative">
            <motion.div
              className="absolute left-6 top-0 hidden h-px w-full origin-left bg-gradient-to-r from-fs-gold/60 via-fs-gold/30 to-transparent lg:block"
              initial={{ scaleX: 0 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1.4, ease: "easeInOut" }}
            />
            <motion.div
              className="absolute left-6 top-0 h-full w-px origin-top bg-gradient-to-b from-fs-gold/60 via-fs-gold/30 to-transparent lg:hidden"
              initial={{ scaleY: 0 }}
              whileInView={{ scaleY: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1.4, ease: "easeInOut" }}
            />

            <div className="grid gap-12 lg:grid-cols-4 lg:gap-8">
              {approachSteps.map((step, i) => {
                const Icon = step.icon;
                return (
                  <motion.div
                    key={step.number}
                    data-testid={`approach-step-${step.number}`}
                    className="relative pl-20 lg:pl-0 lg:pt-16"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] }}
                  >
                    {/* marker */}
                    <span className="absolute left-0 top-0 flex h-12 w-12 items-center justify-center rounded-full border border-fs-gold/50 bg-fs-bg font-serif text-sm text-fs-gold">
                      {step.number}
                    </span>
                    <Icon className="mb-4 h-5 w-5 text-fs-gold/80 lg:mb-5" strokeWidth={1.4} />
                    <h3 className="font-serif text-2xl font-normal tracking-tight text-fs-ink">
                      {step.title}
                    </h3>
                    <p className="mt-3 text-sm leading-relaxed text-fs-muted">
                      {step.desc}
                    </p>
                  </motion.div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
